import { toast } from 'react-toastify';

// Function to show toast notifications
export const showValidationAlert = (message, type = 'success') => {
    const toastOptions = {
        position: 'top-center',
        autoClose: 3000, // Auto close after 3 seconds
        hideProgressBar: true,
        theme: 'colored',
    };

    switch (type) {
        case 'success':
            toast.success(message, toastOptions);
            break;
        case 'info':
            toast.info(message, toastOptions);
            break;
        case 'warning':
            toast.warn(message, toastOptions);
            break;
        default:
            showErrorAlert(message); // Use the separate error handler
    }
};

// Function to handle error alerts with a visible progress bar
export const showErrorAlert = (message) => {
    toast.error(message, {
        position: 'top-center',
        autoClose: 4000, // Auto close after 4 seconds
        hideProgressBar: false, // Show progress bar
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: 'colored',
    });
};

// Function to show delete confirmation toast
export const confirmStatusUpdate = (rowData,empStatus, handleToggleStatus) => {
    toast.error(
        <div>
            <p>Are you sure you want to update emp status {rowData.empName}?</p>
            <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                <button onClick={() => { handleToggleStatus(rowData.empNo,empStatus); toast.dismiss(); }} className="p-button p-button-danger">
                    Yes
                </button>
                <button onClick={() => toast.dismiss()} className="p-button p-button-secondary">
                    No
                </button>
            </div>
        </div>,
        {
            position: "top-center",
            autoClose: false,
            closeButton: false,
            draggable: false,
            hideProgressBar: true
        }
    );
};

// Function to show password reset confirmation toast
export const confirmPwdReset = (rowData, handleResetPassword) => {
    toast.warn(
        <div>
            <p>Are you sure you want to reset the password for {rowData.empName}?</p>
            <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                <button onClick={() => { handleResetPassword(rowData); toast.dismiss(); }} className="p-button p-button-danger">
                    Yes
                </button>
                <button onClick={() => toast.dismiss()} className="p-button p-button-secondary">
                    No
                </button>
            </div>
        </div>,
        {
            position: "top-center",
            autoClose: false,
            closeButton: false,
            draggable: false,
            hideProgressBar: true
        }
    );
};
